import { z } from 'zod'

export const createBillingCycleDiscountSchema = z.object({
  name: z.string().min(1, 'Name is required').max(200, 'Name must not exceed 200 characters'),
  description: z.string().max(500, 'Description must not exceed 500 characters').optional().or(z.literal('')),
  months: z.coerce.number().int().min(1, 'Billing cycle must be at least 1 month').max(120, 'Billing cycle must not exceed 120 months'),
  discountPercent: z.coerce.number().min(0, 'Discount must be at least 0%').max(100, 'Discount must not exceed 100%'),
  currency: z.string().min(1, 'Currency is required').default('VND'),
  isActive: z.boolean().default(true),
  effectiveFrom: z.string().optional(),
  effectiveTo: z.string().optional(),
})

export const updateBillingCycleDiscountSchema = z.object({
  name: z.string().min(1, 'Name is required').max(200, 'Name must not exceed 200 characters').optional(),
  description: z.string().max(500, 'Description must not exceed 500 characters').optional().or(z.literal('')),
  discountPercent: z.coerce.number().min(0, 'Discount must be at least 0%').max(100, 'Discount must not exceed 100%').optional(),
  isActive: z.boolean().optional(),
  effectiveFrom: z.string().optional(),
  effectiveTo: z.string().optional(),
  clearEffectiveFrom: z.boolean().optional(),
  clearEffectiveTo: z.boolean().optional(),
})

export type CreateBillingCycleDiscountFormData = z.infer<typeof createBillingCycleDiscountSchema>
export type UpdateBillingCycleDiscountFormData = z.infer<typeof updateBillingCycleDiscountSchema>
